import { keepPreviousData, useQuery } from '@tanstack/vue-query'
import { computed, toValue, type MaybeRefOrGetter } from 'vue'
import { tradingKeys } from '../tradingQueryKeys'
import { getBuyQuote } from '../tradingEndpoints'
import { parseBuyQuote } from '../tradingParser'
import type { BuyQuoteRequest } from '../../types/tradingTypes'

const EMPTY_REQUEST: BuyQuoteRequest = { tokenQuantity: 0 }

// Server-priced buy quote (POST, read-only). Business-rule problems come back
// in `errors`, not as a failure. The caller debounces `request` so a slider
// drag doesn't fire a request per step; null pauses the query.
export function useBuyQuoteQuery(
  listingId: MaybeRefOrGetter<string>,
  request: MaybeRefOrGetter<BuyQuoteRequest | null>,
) {
  return useQuery({
    queryKey: computed(() =>
      tradingKeys.buyQuote(toValue(listingId), toValue(request) ?? EMPTY_REQUEST),
    ),
    queryFn: () =>
      getBuyQuote(toValue(listingId), toValue(request) ?? EMPTY_REQUEST).then(parseBuyQuote),
    enabled: () => Boolean(toValue(listingId)) && toValue(request) !== null,
    // The figures stay on screen while the next quantity prices.
    placeholderData: keepPreviousData,
  })
}
